var site = site || {};

(function ($) {
  Drupal.behaviors.power_of_the_night_beauty_sleep_quiz_v1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $module = $('.anr_repromote_mod5', context);

      $module.each(function () {
        const $thismodule = $(this);
        const triggerMod = '#anr_repromote_mod5';
        const thisModuleName = 'anr_repromote_mod5';
        const controller = new ScrollMagic.Controller();
        const moduleWillFade = $thismodule.data('scrollmagic') === 1;
        const $startQuiz = $thismodule.find('.js-anr__quiz-btnStart');
        const $quizQuestionSection = $thismodule.find('.js-anr__quiz-qs');
        const $eachQuestionSection = $quizQuestionSection.find('.js-anr__quiz-q');
        const $theFirstQuestion = $quizQuestionSection.find('.js-anr__quiz-q-1');
        const $options = $thismodule.find('.js-anr__quiz-option');
        const $nextBtn = $thismodule.find('.js-anr__quiz-btnNext');
        const $closeBtn = $thismodule.find('.js-anr__quiz-close');
        const $ansBtn = $thismodule.find('.js-anr__quiz-btnAns');
        const $resultsSection = $thismodule.find('.js-anr__quiz-results');
        const $resultsImage = $thismodule.find('.js-anr__quiz-resultimage');
        const $resultsHeader = $thismodule.find('.js-anr__quiz-resultsHeader');
        const $resultsSubheader = $thismodule.find('.js-anr__quiz-resultsSubheaderPC');
        const $productsCarousel = $thismodule.find('.js-tny__quiz-products_carousel');
        const $resultReturned = $resultsSection.find('.js-anr__quiz-result');
        const $resetQuizOptions = $thismodule.find('.js-anr__quiz-option');
        const $questionsHeader = $thismodule.find('.js-anr__quiz-questionHeader');
        const $quizBgContainer = $thismodule.find('.js-anr_quiz-bgcontainer');
        const allQuizOptions = '.js-anr__quiz-option';
        const quizQuestions = '.js-anr__quiz-q';
        const singleOptFlag = 'anr__quiz-tempInactive';
        let theQuizCounter = 10;
        let parentIndex, optionIndex, counterDirection;
        const urlHash = window.location.href.split('#')[1];
        const windowHeight = $(window).height();
        const parallaxDuration = windowHeight / 4;
        let tweenParallaxVal;
        var $carouselTiles;
        var $carouselWrapper;
        var tileWidth;
        var $mppProducts;
        var $leftChevronElem, $rightChevronElem;
        var carouselMoveIndex = 3;
        var isAnimating = false;
        var slidesDisplayed = 3;
        var desktopMediumWidth = 1180;
        var mobileWidth = 767;
        var currentQuestion = 0;
        var currentAnswer = '';
        var $quizContainer = $thismodule.find('.js-anr__quiz-qContainer');
        var $parent = $thismodule.closest('.power-night__beauty-sleep-quiz');
        var $resultsTreatment = $resultsSection.find('.anr__quiz-resultsTreatment');
        var $download = $resultsSection.find('.js-anr__quiz-resultsDownload');
        var $store = $resultsSection.find('.js-anr__quiz-resultsStore');

        if ($(window).width() < 768) {
          tweenParallaxVal = '0';
        } else {
          tweenParallaxVal = '0';
        }

        const optionClickVals = [
          {
            values: [
              {
                value: -1
              }, {
                value: -1
              }, {
                value: -1
              }, {
                value: 0
              }, {
                value: 1
              }
            ]
          },
          {
            values: [
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: -1
              }
            ]
          },
          {
            values: [
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: 1
              }
            ]
          },
          {
            values: [
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: 1
              }
            ]
          }
        ];

        // If module is called in URL, scroll to module.
        if (urlHash === thisModuleName) {
          $('html,body').animate({
            scrollTop: $thismodule.offset().top - 85
          }, 1500);
        }
        if (window.location.href.indexOf('beauty_sleep_quiz') > -1) {
          $('html, body').animate({
            scrollTop: $quizQuestionSection.offset().top - 150
          }, 1500, 'easeInOutQuad');
          $startQuiz.trigger('click');
        }

        // Hide and push down the module if it is to be faded in.
        if (moduleWillFade) {
          $thismodule.addClass('hideModules');
        }

        // Parallaxing the quiz landing bg.
        new ScrollMagic.Scene({
          triggerElement: triggerMod,
          offset: 0,
          duration: parallaxDuration
        }).setTween('.anr__quiz-landingBg', 8, {
          marginTop: tweenParallaxVal,
          ease: Linear.easeNone
        }).addTo(controller);

        // Begin the quiz
        $startQuiz.on('click', function () {
          if (!$startQuiz.hasClass('quiz_active')) {
            $quizQuestionSection.addClass('anr__quiz-qs--answerscreen');
            $startQuiz.addClass('quiz_active');
            if (isMobile()) {
              // css override
              $quizQuestionSection.css('display', 'block');
              setMobileHeights();
            }
            // analytics start quiz
            fireAnalytic('start', 'click');
            $quizQuestionSection.addClass('active');
            $questionsHeader.fadeIn();
            $quizQuestionSection.slideDown();
            $('html, body').animate({
              scrollTop: $quizQuestionSection.offset().top - 150
            }, 1500, 'easeInOutQuad');

            // analytics first question loaded
            fireAnalytic('step 1', 'load');

            if (!carouselSetupCheck()) {
              var isStandAlone = !$parent.hasClass('power-night__staying-in');

              carouselSetup(isStandAlone);
              var $carouselProducts = $thismodule.find('.mpp');

              $carouselProducts.addClass('carouselready');
            }
          }
        });

        // Close & restart the quiz.
        $closeBtn.on('click', function () {
          $quizQuestionSection.removeClass('anr__quiz-qs--answerscreen');
          $quizQuestionSection.slideUp(function () {
            if (isMobile()) {
              $quizQuestionSection.removeClass('active');
              $quizContainer.removeClass('inactive');
              // css override
              $quizQuestionSection.css('display', 'none');
              mobileRearrange(false);
            }
            $startQuiz.removeClass('quiz_active');
            $eachQuestionSection.add($resultsSection).fadeOut();
            $resultsSection.removeClass('active');
            $resultsImage.fadeOut();
            $resetQuizOptions.removeClass('button--dark active inactive').addClass('button--light');
            $nextBtn.addClass('anr__quiz-btnInactive');
            $theFirstQuestion.fadeIn();
            theQuizCounter = 10;
          });
          currentQuestion = 0;
        });

        // When a button is deactivated.
        function inactiveOption(which) {
          which.removeClass('button--light').addClass('button--dark active');
          which.siblings('button').removeClass('anr__quiz-btnInactive');
        }

        // When a button is activated.
        function activeOption(which) {
          which.removeClass('button--dark active').addClass('button--light');
          if (!which.siblings(allQuizOptions).hasClass('active')) {
            which.siblings('button').addClass('anr__quiz-btnInactive');
          }
        }

        function setCurrentAnswer($which) {
          var $answers = $which.siblings(),
            answerString = String($which.html());

          $.each($answers, function (ans_index, ans_value) {
            var $ans = $(ans_value);

            if ($ans.hasClass('active')) {
              answerString = answerString + '.' + String($ans.html());
            }
          });
          currentAnswer = answerString;
        }

        /* Engagement analytics */
        function fireAnalytic(eventAction, eventLabel) {
          site.track.evtLink({
            event_name: 'elOwnTheNight',
            event_category: 'own the night',
            event_action: eventAction,
            event_label: eventLabel
          });
        }

        // Increment/ decrement counter
        function counterValueDirection($which) {
          if ($which.hasClass('active')) {
            counterDirection = 'decrement';
            activeOption($which);
          } else {
            counterDirection = 'increment';
            setCurrentAnswer($which);
            inactiveOption($which);
          }
        }

        // Check if this is a single-option question
        function checkWrapper($which) {
          if ($which.parent().hasClass('js-anr__quiz-singleOpt')) {
            if ($which.hasClass(singleOptFlag)) {
              $which.removeClass(singleOptFlag);
              $which.siblings().not('button').addClass(singleOptFlag);
            } else {
              $which.siblings().not('button').addClass(singleOptFlag);
            }
          }
          counterValueDirection($which);
        }

        // Handle the score incrementation/decrementation.
        function incrementOptions(parentIndex, optionIndex, counterDirection) {
          parentIndex = parentIndex - 1;
          if (counterDirection === 'increment') {
            theQuizCounter = theQuizCounter + optionClickVals[parentIndex].values[optionIndex].value;
          } else {
            theQuizCounter = theQuizCounter - optionClickVals[parentIndex].values[optionIndex].value;
          }
        }

        function cloneTiles() {
          var $firstSlide = $carouselTiles.first();
          var $lastSlide = $carouselTiles.last();
          var $firstSlideClone = $firstSlide.clone();
          var $secondSlideClone = $firstSlide.next().clone();
          var $thirdSlideClone = $firstSlide.next().next().clone();
          var $lastSlideClone = $lastSlide.clone();
          var $secondLastSlideClone = $lastSlide.prev().clone();
          var $thirdLastSlideClone = $lastSlide.prev().prev().clone();
          var $carouselInner = $thismodule.find('.js-tny-quiz-carousel__inner');

          $thirdLastSlideClone.insertBefore($carouselInner);
          $secondLastSlideClone.insertBefore($carouselInner);
          $lastSlideClone.insertBefore($carouselInner);

          $thirdSlideClone.insertAfter($carouselInner);
          $secondSlideClone.insertAfter($carouselInner);
          $firstSlideClone.insertAfter($carouselInner);
        }

        function applySlideWidths() {
          tileWidth = $($carouselTiles[0]).outerWidth(true);
          var totalWidth = ($carouselTiles.length + 6) * tileWidth; // 6 clones. 3 at the end and 3 at the beginning

          $carouselWrapper = $thismodule.find('.js-tny-quiz-carousel__wrapper');
          $carouselWrapper.width(totalWidth);
          $carouselWrapper.css('margin-left', '-100%'); // move passed the first clone slide
        }

        function createArrows() {
          var leftArrow = $($thismodule.find('.tny__quiz-results--arrows')[0]), rightArrow = $($thismodule.find('.tny__quiz-results--arrows')[1]), $leftArrowContainer = $('<div class="tny-quiz-carousel__nav js-tny-quiz-carousel__nav tny-quiz-carousel__nav--left js-tny-quiz-carousel__nav--left">'), $rightArrowContainer = $('<div class="tny-quiz-carousel__nav js-tny-quiz-carousel__nav tny-quiz-carousel__nav--right js-tny-quiz-carousel__nav--right">');

          $leftArrowContainer.insertBefore($thismodule.find('.mpp__product-grid'));
          $rightArrowContainer.insertAfter($thismodule.find('.mpp__product-grid'));

          $leftArrowContainer.append(leftArrow);
          $rightArrowContainer.append(rightArrow);

          $leftChevronElem = $thismodule.find('.js-tny-quiz-carousel__nav--left');
          $rightChevronElem = $thismodule.find('.js-tny-quiz-carousel__nav--right');
        }

        /* Set new position of the carousel */
        function updateCarouselPosition() {
          var newPosition = carouselMoveIndex * (100 / slidesDisplayed);

          $carouselWrapper.css('margin-left', '-' + newPosition + '%');
          // animation ends
          setTimeout(function () {
            $carouselWrapper.removeClass('tny-quiz-carousel__wrapper--stalled');
            isAnimating = false;
          }, 500);
        }

        /* All animation functionality for the carousel */
        function moveCarousel() {
          updateCarouselPosition();
          if (carouselMoveIndex > ($carouselTiles.length + 2)) {
            // animation ends
            setTimeout(function () {
              carouselMoveIndex = 3;
              $carouselWrapper.addClass('tny-quiz-carousel__wrapper--stalled');
              updateCarouselPosition();
            }, 320);
          }
          if (carouselMoveIndex === 2) {
            // animation ends
            setTimeout(function () {
              carouselMoveIndex = $carouselTiles.length + 2;
              $carouselWrapper.addClass('tny-quiz-carousel__wrapper--stalled');
              updateCarouselPosition();
            }, 320);
          }
        }

        // left click handler
        function leftChevronElemClicked() {
          if (isAnimating === false) {
            carouselMoveIndex--;
            isAnimating = true;
            moveCarousel();
          }
        }

        // right click handler
        function rightChevronElemClicked() {
          if (isAnimating === false) {
            carouselMoveIndex++;
            isAnimating = true;
            moveCarousel();
          }
        }

        function setArrowListeners() {
          $leftChevronElem.click(function () {
            leftChevronElemClicked();
          });
          $rightChevronElem.click(function () {
            rightChevronElemClicked();
          });
        }

        function createCarousel() {
          // clone slides for "infinity" carousel effect
          cloneTiles();
          // carousel arrows
          createArrows();
          // setting widths for animation
          applySlideWidths();
          // custom arrows and listeners
          setArrowListeners();
          // set resize listener
          responsiveLayout();

          $(window).on('resize', _.debounce(responsiveLayout, 500));

          $mppProducts.addClass('showing');
        }

        function carouselSetupCheck() {
          var $productsCarouselWrapper = $productsCarousel.find('.js-tny-quiz-carousel__wrapper');

          if ($productsCarouselWrapper && $productsCarouselWrapper.length > 0) {
            return true;
          }

          return false;
        }

        function carouselSetup(standalone) {
          var windowWidth = $(window).width();

          $mppProducts = $parent.next('.js-mpp-wrapper');
          if (isMobile()) {
            if (standalone) {
              $mppProducts = $parent.next('.mpp');
            } else {
              $mppProducts = $parent.siblings('.basic-textarea-v1').next('.mpp');
            }
          }
          if ($mppProducts.length === 0) {
            $mppProducts = $parent.parent().next('.js-mpp-wrapper');
          }

          $productsCarousel.append($mppProducts);
          $carouselTiles = $thismodule.find('.mpp__product');
          if (windowWidth <= mobileWidth) {
            $carouselTiles = $thismodule.find('.js-pr-product');
            if ($carouselTiles.length === 0) {
              $carouselTiles = $thismodule.find('.product-brief');
            }
          }

          $carouselTiles.wrapAll('<div class="tny-quiz-carousel__wrapper js-tny-quiz-carousel__wrapper"><div class="tny-quiz-carousel__inner js-tny-quiz-carousel__inner"></div></div>');
          createCarousel();
        }

        function mobileRearrange(resultsPage) {
          if (resultsPage) {
            $resultsHeader.insertBefore($resultsImage);
            $resultsSubheader.insertBefore($resultsImage);
            $quizBgContainer.addClass('anr_quiz-bgcontainer--inactive');
            var $stayingInBeautyQuiz = $thismodule.closest('.power-night__staying-in.power-night__beauty-sleep-quiz');
            var $stayingInBeautyQuizCarousel = $stayingInBeautyQuiz.find('.js-tny-quiz-carousel__wrapper');
            var $stayingInBeautyQuizProducts = $stayingInBeautyQuizCarousel.children();

            $.each($stayingInBeautyQuizProducts, function (prod_index, prod_value) {
              var $product = $(prod_value);

              $product.addClass('product-brief--stayinginquiz');
            });
          } else {
            $resultsSection.prepend($resultsSubheader);
            $resultsSection.prepend($resultsHeader);
            $quizBgContainer.removeClass('anr_quiz-bgcontainer--inactive');
            $quizContainer.children().removeClass('js-anr__quiz-q-mobile-ready');
          }
        }

        // Clicking on the answers.
        $options.on('click', function () {
          var $this = $(this);

          if ($this.hasClass(singleOptFlag)) {
            $this.siblings('.active').trigger('click');
          }
          parentIndex = $(this).parent().parent(quizQuestions).index() + 1;
          optionIndex = $this.index();
          checkWrapper($this);
          incrementOptions(parentIndex, optionIndex, counterDirection);
        });

        /* Clicking download analytic */
        $download.on('click', function () {
          fireAnalytic('step ' + currentQuestion, 'download');
        });

        /* Clicking store analytic */
        $store.on('click', function () {
          fireAnalytic('step ' + currentQuestion, 'store');
        });

        // Clicking to the next set of questions.
        $nextBtn.on('click', function () {
          $(this).closest($eachQuestionSection).fadeOut().next().delay(200).fadeIn();
          currentQuestion++;
          // step answer analytic
          fireAnalytic('step ' + currentQuestion, 'answers | ' + currentAnswer);
          var _currentQuestion = Number(currentQuestion);

          _currentQuestion++;
          // next question load analytic
          fireAnalytic('step ' + _currentQuestion, 'load');
        });

        // Returning the score and showing the score view.
        $ansBtn.on('click', function () {
          $quizQuestionSection.removeClass('anr__quiz-qs--answerscreen');
          $eachQuestionSection.add($questionsHeader).fadeOut();
          $resultsSection.delay(200).fadeIn().addClass('active');
          $resultsImage.delay(200).fadeIn();
          if (theQuizCounter < 3) {
            theQuizCounter = 3;
          }
          $resultReturned.text(theQuizCounter);
          if (isMobile()) {
            mobileRearrange(true);
            $quizContainer.addClass('inactive');
            $('html, body').animate({
              scrollTop: $quizQuestionSection.offset().top - $quizQuestionSection.height()
            }, 500);
          }
          currentQuestion++;
          // current step answer analytic
          fireAnalytic('step ' + currentQuestion, 'answers | ' + currentAnswer);

          currentQuestion++;
          // results analytic
          fireAnalytic('step ' + currentQuestion, 'results | ' + String($resultsTreatment.html()) + ' | Score-' + $resultReturned.html());
        });

        function setMobileHeights() {
          var questions = $quizContainer.children(),
            maxHeight = 0;

          $.each(questions, function (q_index, q_value) {
            var $question = $(q_value),
              fullHeight = $question.outerHeight(true);

            if (fullHeight > maxHeight) {
              maxHeight = fullHeight;
            }
            $question.addClass('js-anr__quiz-q-mobile-ready');
          });
          $quizContainer.css('height', maxHeight + 20);
        }

        function isMobile() {
          var windowWidth = $(window).width(), isMob = false;

          if (windowWidth < mobileWidth) {
            isMob = true;
          }

          return isMob;
        }

        // Carousel responsiveness
        function responsiveLayout() {
          var windowWidth = $(window).width();

          if (!$mppProducts) {
            $mppProducts = $thismodule.find('.js-mpp-wrapper');
          }
          if (windowWidth < desktopMediumWidth) {
            $mppProducts.addClass('TwoDisplay');
            slidesDisplayed = 2;
          } else {
            $mppProducts.removeClass('TwoDisplay');
            slidesDisplayed = 3;
          }
          isAnimating = true;
          moveCarousel();
        }
        // css override
        $quizQuestionSection.css('display', 'none');
      });
    }
  };
})(jQuery);
